import { ChangeDetectionStrategy, Component, OnInit, inject, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FileExplorerComponent } from '@/pages/tools/file-explorer/file-explorer.component';
import { FILE_EXPLORER_SERVICE } from 'src/api/file-explorer.service.interface';
import { CloudFileExplorerService } from '@/cloud/services/cloud-file-explorer.service';
import { DeviceContextService } from '../device-context.service';

/**
 * Cloud wrapper for the file explorer.
 * Provides CloudFileExplorerService (pre-loaded with deviceId) to the
 * shared FileExplorerComponent via the FILE_EXPLORER_SERVICE injection token.
 */
@Component({
    selector: 'app-cloud-file-explorer',
    standalone: true,
    imports: [FileExplorerComponent, CommonModule],
    template: `<app-file-explorer *ngIf="ready()" />`,
    styles: [`
    :host {
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
    }
  `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        CloudFileExplorerService,
        { provide: FILE_EXPLORER_SERVICE, useExisting: CloudFileExplorerService }
    ]
})
export class CloudFileExplorerComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private deviceCtx = inject(DeviceContextService);
    private fileExplorerService = inject(CloudFileExplorerService);

    ready = signal(false);
    private readonly explorer = viewChild(FileExplorerComponent);

    async canDeactivate(): Promise<boolean> {
        return this.explorer()?.canDeactivate() ?? true;
    }

    ngOnInit(): void {
        // Get deviceId from route params first, fall back to context
        const deviceId = this.route.snapshot.paramMap.get('deviceId') ?? this.deviceCtx.device()?.id ?? '';
        console.log('[CloudFileExplorer] Initializing with deviceId:', deviceId);
        if (deviceId) {
            this.fileExplorerService.setDeviceId(deviceId);
            this.ready.set(true);
            console.log('[CloudFileExplorer] Service ready');
        } else {
            console.warn('[CloudFileExplorer] No deviceId found!');
        }
    }
}
